import React from "react"
import types from "prop-types"
import { workflowConditionShape } from "utils/propTypeShapes"
import {
  QUESTION_ANSWER_CONDITION_PROPERTY,
  SUBFORM_ANSWER_CONDITION_PROPERTY,
  STATUS_CONDITION_PROPERTY,
  SUBMISSION_AGE_CONDITION_PROPERTY,
  SUBMITTED_FORM_PROPERTY,
  FLAG_COUNT_CONDITION_PROPERTY,
} from "utils/workflowHelpers"
import * as ValueDefiners from "./ConditionValueDefiners/index"

const DefineConditionValue = ({
  condition,
  changeConditionValue,
  className = "",
  conditionIndex,
}) => {
  let ValueDefiner
  switch (condition.property) {
  case STATUS_CONDITION_PROPERTY:
    ValueDefiner = ValueDefiners.DefineStatusValue;
    break;
  case QUESTION_ANSWER_CONDITION_PROPERTY:
  case SUBFORM_ANSWER_CONDITION_PROPERTY:
    ValueDefiner = ValueDefiners.DefineQuestionAnswerValue;
    break;
  case SUBMISSION_AGE_CONDITION_PROPERTY:
    ValueDefiner = ValueDefiners.DefineSubmissionAgeValue;
    break;
  case SUBMITTED_FORM_PROPERTY:
    ValueDefiner = ValueDefiners.DefineSubmittedFormValue;
    break;
  case FLAG_COUNT_CONDITION_PROPERTY:
    ValueDefiner = ValueDefiners.DefineFlagCountValue;
    break;
  default:
    return null
  }

  return (
    <ValueDefiner
      condition={condition}
      changeConditionValue={changeConditionValue}
      className={className}
      conditionIndex={conditionIndex}
    />
  )
}

DefineConditionValue.propTypes = {
  condition: workflowConditionShape.isRequired,
  changeConditionValue: types.func.isRequired,
  conditionIndex: types.number.isRequired,
  className: types.string,
}

export default DefineConditionValue
